import type { SVGProps } from "react";
export interface ParkIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ParkIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ParkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.375 18.064V14a1.125 1.125 0 0 1 2.25 0v4.064a1.125 1.125 0 0 1-2.25 0m9 0V14a1.125 1.125 0 0 1 2.25 0v4.064a1.125 1.125 0 0 1-2.25 0M6.501.875c1.167 0 2.102.612 2.704 1.488.453.66.724 1.475.825 2.35.444.226.836.531 1.157.9l.203.254.065.097a1.126 1.126 0 0 1-1.81 1.32l-.071-.09-.084-.105a1.6 1.6 0 0 0-.817-.498A1.13 1.13 0 0 1 7.826 5.5c0-.83-.205-1.469-.476-1.864-.256-.373-.546-.511-.85-.511s-.593.138-.849.511c-.271.395-.476 1.033-.476 1.864 0 .514-.349.964-.847 1.09a1.58 1.58 0 0 0-1.151 1.132c-.135.514-.038 1.242.696 1.99.334.34.416.855.206 1.284-.597 1.219-.407 1.995-.063 2.45.34.448 1.007.823 1.968.91l.429.019.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006-.31-.007c-1.547-.069-3-.653-3.88-1.814-.853-1.126-1.006-2.577-.457-4.107C.94 9.575.7 8.307 1 7.153a3.83 3.83 0 0 1 1.97-2.442c.101-.874.374-1.688.827-2.348C4.398 1.487 5.334.875 6.5.875Z"
      />
      <path
        fill={color}
        d="M5.375 22V9a1.125 1.125 0 0 1 2.25 0v13a1.125 1.125 0 0 1-2.25 0m15.5 0v-2a.88.88 0 0 0-.519-.8l-.136-.047a1 1 0 0 0-.22-.028h-8a1 1 0 0 0-.112.007l-.107.02a.876.876 0 0 0-.656.848v2a1.125 1.125 0 0 1-2.25 0v-2c0-1.458.997-2.68 2.345-3.027l.19-.042q.289-.056.59-.056h8A3.126 3.126 0 0 1 23.125 20v2a1.125 1.125 0 0 1-2.25 0m-9.25-9.126h8.75v-1.249h-8.75zm11 .626c0 .897-.727 1.624-1.624 1.624H11A1.624 1.624 0 0 1 9.375 13.5V11c0-.898.727-1.625 1.624-1.625h10c.898 0 1.625.727 1.625 1.624z"
      />
    </svg>
  );
}
